/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadLoginVerifyResponse
 */
export interface UploadLoginVerifyResponse {
    /**
     * 
     */
    name: string;
}

/**
 * Check if a given object implements the UploadLoginVerifyResponse interface.
 */
export function instanceOfUploadLoginVerifyResponse(value: object): value is UploadLoginVerifyResponse {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function UploadLoginVerifyResponseFromJSON(json: any): UploadLoginVerifyResponse {
    return UploadLoginVerifyResponseFromJSONTyped(json, false);
}

export function UploadLoginVerifyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadLoginVerifyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function UploadLoginVerifyResponseToJSON(json: any): UploadLoginVerifyResponse {
    return UploadLoginVerifyResponseToJSONTyped(json, false);
}

export function UploadLoginVerifyResponseToJSONTyped(value?: UploadLoginVerifyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

